import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Popup from '../../../common/Popup';
import * as irActions from '../../../../redux/actions/irSearch';
import loadingSpinnerImage from '../../../../images/loadingSpinner.gif';
import ProgressBar from '../../../common/ProgressBar/ProgressBar';


class EmailFormPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: props.favoriteEmail.email || '',
      text: '',
    };
  }

  componentDidMount() {
    this.props.dispatch(irActions.loadFavoriteEmails());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.favoriteEmail.status !== this.props.favoriteEmail.status
        && this.props.favoriteEmail.status === 'done') {
      this.setState({ email: this.props.favoriteEmail.email });
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    const { email, text } = this.state;

    const params = {
      ...this.props.popup.data,
      email_address: email,
      email_message: text,
    };

    this.props.onSubmit(params);
  }

  handleEmailChange = (e) => {
    e.preventDefault();
    this.setState({ email: e.target.value });
  }

  handleTextChange = (e) => {
    e.preventDefault();
    this.setState({ text: e.target.value });
  }

  renderProgress = percentage => (
    <div>
      <ProgressBar percentage={percentage || 5} show />
    </div>
  );

  render() {
    const isLoading = this.props.favoriteEmail.status === 'loading';

    return (
      <Popup show={this.props.popup.show}
             clsName="email-popup"
             topBarTitle="Email Combined PDFs"
             onClose={this.props.onClose}>
        <div className="inner-text">
          <div>
            <p>
              <label htmlFor="email">Email (separate with commas)</label>
              <br />
              <input type="text"
                     name="email"
                     size="40"
                     onChange={this.handleEmailChange}
                     value={this.state.email} />
            </p>
            <p>
              <label htmlFor="email">Message (optional)</label>
              <br />
              <textarea name="message"
                        rows="5"
                        cols="50"
                        onChange={this.handleTextChange}
                        value={this.state.text} />
            </p>
          </div>

          { isLoading &&
            <div>
              <img src={loadingSpinnerImage} />
            </div>
          }

        </div>

        <div className="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
          <div className="ui-dialog-buttonset">
            <button type="button" onClick={this.props.onClose}>Cancel</button>
            <button type="button" onClick={this.onSubmit}>Send</button>
          </div>
        </div>
      </Popup>
    );
  }
}

EmailFormPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  favoriteEmail: PropTypes.object.isRequired,
  popup: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { popup, favoriteEmail } = state.get('dockets').toJS();

  return {
    popup,
    favoriteEmail,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailFormPopup);



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/popups/EmailFormPopup.jsx
 **/